import React from 'react';
import { useAppDispatch, useAppSelector } from '../../../../app/hooks';
import { changeToMoney, changeToPercentage, selectValueDisplay, DISPLAY_OPTIONS } from './value-display-flip-button-slice';

/**
 * A button that flips on click and alternates displayed portfolio values between MONEY (R$) and PERCENTAGE (%).
 */
const ValueDisplayFlipButton: React.FC = () => {

  // Get the 'dispatch' method from the store
  const dispatch = useAppDispatch();
  const valueDisplay = useAppSelector(selectValueDisplay);

  const flipHandler = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    if (e.currentTarget.getAttribute("data-selected") === 'front') {
      dispatch(changeToPercentage());
    } else {
      dispatch(changeToMoney());
    }
  }

  return (
    <div>
      <div className="group relative font-semibold select-none rounded-full items-center [perspective:200px]" data-selected={valueDisplay.displayOption === DISPLAY_OPTIONS.MONEY ? 'front' : 'back'} onClick={flipHandler}>
        <div title="Escolha ver em R$ ou %" className={`flex w-11 h-5 lg:h-6 text-xs items-center cursor-pointer rounded-full text-slate-200 hover:text-slate-50 bg-slate-300/80 dark:bg-slate-300/80 hover:opacity-85 shadow-sm shadow-slate-900/80`}>
          <div className='absolute z-10 left-0 group-data-[selected=back]:!left-5 w-6 rounded-full border border-slate-300/80 dark:border-slate-300/80 bg-slate-800 h-full transition-all ease-in-out duration-300'></div>
          <div className="absolute flex z-20 left-0 h-full rounded-full w-6 items-center justify-center group-data-[selected=back]:text-slate-800">
            <p>R$</p>
          </div>
          <div className="absolute flex z-20 right-0 h-full rounded-full w-6 items-center justify-center group-data-[selected=front]:text-slate-800">
            <p>%</p>
          </div>
        </div >
      </div>
    </div>
  );
}

export default ValueDisplayFlipButton;